/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLibrary = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m18.847 2 3.333 20h-7.027L14 15.087V22H2V2zM7 18H4v2h3zm5 0H9v2h3zm5.152-14H14.18l2.667 16h2.972zM7 8H4v8h3zm5 0H9v8h3zM7 4H4v2h3zm5 0H9v2h3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLibrary as Library };
